<template>
  <label class="form-label d-flex align-items-center" v-if="label">
    {{ label }}
    <span v-if="isRequired" class="text-danger">*</span>
  </label>
  <div class="input-group" :style="containerStyle">
    <button 
      class="btn btn-sm btn-outline-secondary m-0" 
      type="button" 
      @click="decrement"
      :disabled="disabled || (min !== undefined && modelValue <= min)"
    >
      <i class="material-icons" style="font-size: 16px;">remove</i>
    </button>
    <input 
      readonly 
      :size="size" 
      :id="id" 
      name="value" 
      :value="modelValue || 0" 
      @click="handleClick"
      class="form-control text-center"
      :style="inputStyle"
      :disabled="disabled"
    />
    <button 
      class="btn btn-sm btn-outline-secondary m-0" 
      type="button" 
      @click="increment"
      :disabled="disabled || (max !== undefined && modelValue >= max)"
    >
      <i class="material-icons" style="font-size: 16px;">add</i>
    </button>
  </div>
</template>

<script setup>
// import { computed } from 'vue';

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  label: {
    type: String,
    default: '',
  },
  isRequired: {
    type: Boolean,
    default: false,
  },
  modelValue: {
    type: [Number, String],
    default: 0,
  },
  min: {
    type: [Number, String],
    default: undefined,
  },
  max: {
    type: [Number, String],
    default: undefined,
  },
  size: {
    type: [Number, String],
    default: 3,
  },
  inputStyle: {
    type: [String, Object],
    default: () => ({ width: '60px' }),
  },
  containerStyle: {
    type: [String, Object],
    default: () => ({ width: 'auto' }),
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  onSpinnerClick: {
    type: Function,
    default: null,
  },
});

const emit = defineEmits(['update:modelValue', 'change']);

const handleClick = () => {
  if (props.onSpinnerClick && typeof props.onSpinnerClick === 'function') {
    props.onSpinnerClick(props.id, props.min, props.max);
  }
};

const increment = () => {
  if (props.disabled) return;
  
  const currentValue = Number(props.modelValue) || 0;
  const maxValue = props.max !== undefined ? Number(props.max) : 999;
  
  if (currentValue < maxValue) {
    const newValue = currentValue + 1;
    emit('update:modelValue', newValue);
    emit('change', newValue);
  }
};

const decrement = () => {
  if (props.disabled) return;
  
  const currentValue = Number(props.modelValue) || 0;
  const minValue = props.min !== undefined ? Number(props.min) : 0;
  
  if (currentValue > minValue) {
    const newValue = currentValue - 1;
    emit('update:modelValue', newValue);
    emit('change', newValue);
  }
};
</script>


